<div class="container">
    <div class="notfound">
      <img src="/assets/graphics/404-page-not-found.svg" alt="Not Found Image" class="notfound__image">
      <h2 class="notfound__text">This educator could not be found.</h2>
    </div>
  </div>